//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateVehiculos } from "@/typings/store/plugins/easyFirestore/vehiculos";

const getters: GetterTree<StateVehiculos, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const vehiculos = {
  firestorePath: "{env}/v1/empresas/{idEmpresa}/vehiculos",
  firestoreRefType: "collection",
  moduleName: "vehiculos",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default vehiculos;
